import { BreakoutButton } from 'components/design-system/BreakoutButton'
import { useTranslationTyped } from 'i18n/i18n'

export function RequestedState({
  setWantsInvoicing,
}: {
  setWantsInvoicing: (value: boolean) => void
}) {
  const { t } = useTranslationTyped()

  return (
    <div className="invoicing-submitted flex min-h-full w-full flex-col items-start justify-center">
      <div className="ml-[5vw] max-w-[400px]">
        <div className="mb-5">
          <h1 className="text-headline-large">
            {t('lti.configuration.invoice_request_submitted')}
          </h1>
          <div className="text-body-large">
            {t('lti.configuration.wants_invoice_class_description')}
          </div>
        </div>
        <BreakoutButton
          onClick={() => setWantsInvoicing(false)}
          kind="accent"
          type="submit"
          size="medium"
        >
          {t('lti.configuration.continue')}
        </BreakoutButton>
      </div>
    </div>
  )
}
